import { createFileRoute } from '@tanstack/react-router';

import { NIS2ReportsHub } from '@/features/nis2/components/NIS2ReportsHub';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/nis2/reports/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2Reports'),
  }),
  component: NIS2ReportsHub,
});
